import { DirectiveBinding } from "vue";
import sanitizer from "sanitize-html";

export default (el: HTMLElement, binding: DirectiveBinding<any>) => {
  const arg = binding.arg;
  switch (arg) {
    case "simple":
      el.innerHTML = sanitizer(binding.value, {
        allowedTags: ["br", "strong"],
        allowedAttributes: {},
      });
      break;
    default:
      el.innerHTML = sanitizer(binding.value, {
        allowedTags: [],
        allowedAttributes: {},
      });
      break;
  }
};
